<template>
  <div class="help">
    <div class="home--header">
      <div class="title--back iconfont" @click="$router.push('/')"><span>&#xe600;</span></div>
      帮助手册
      <div class="title--add iconfont"></div>
    </div>
    <div class="help-line"></div>
    <div class="help-content">
      <div class="help-content-item">
        <div class="help-item-title">1.第一次拜访客户，需要填写哪些内容？</div>
        <div class="help-item-desc">
          答：第一次拜访客户时，需要新增一户“客户/渠道”（可提前填写），然后还需要新增一份本次“营销日志”。
        </div>
      </div>
      <div class="help-content-item">
        <div class="help-item-title">2.客户现场没时间写营销日志，怎么办？</div>
        <div class="help-item-desc">
          答：用户可以在客户现场，新增一份“营销日志”，选择客户并定位后，保存为草稿，后续在草稿箱中找到该草稿，完善内容后再提交。
        </div>
      </div>
      <div class="help-content-item">
        <div class="help-item-title">3.什么样的客户会进入公海？</div>
        <div class="help-item-desc">
          答：满足①②③中的任何一个，并且满足④ <br>
          ①前1个月无营销日志，无后1个月内的下一步计划。 <br>
          ②前2个月无营销日志。<br>
          ③营销日志中选择不继续跟进。<br>
          ④综合业务系统，没有该客户对应的业务受理审批通过的记录。<br>
        </div>
      </div>
      <div class="help-content-item">
        <div class="help-item-title">4.营销管理系统如何对接综合业务系统？</div>
        <div class="help-item-desc">
          答：综合业务系统中操作业务受理时，如果该客户有前置营销记录，需要对应绑定，防止客户被错误丢入公海。
        </div>
      </div>
      <div class="help-content-item">
        <div class="help-item-title">5.营销管理系统对营销同一客户的规则，是怎么样的？</div>
        <div class="help-item-desc">
          答：同一个业务人员，不允许新增相同正在营销的客户。不同业务人员，允许新增相同正在营销的客户，并且会互相提醒，后期可以通过客户/渠道明细下的“其他事项”，查询对方的营销日志。
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import recordPageTime from '../mixin/minin'
export default {
  name: 'Help',
  mixins: [recordPageTime]
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.help
  position : relative
  width : 100vw
  height : 100vh
  overflow : hidden
  background-color : #ffffff
  .home--header
    position : fixed
    top:0
    left :0
    width : 100%
    display : flex
    justify-content : space-between
    align-items center
    height : 85px
    line-height : 85px
    text-align : center
    background : #687591
    font-family: MyriadPro-Regular
    font-size: 38px
    font-weight: normal
    font-stretch: normal
    color: #ffffff
    .title--back
      padding : 16px
      font-size : 32px
  .help-line
    width : 100%
    height : 85px
  .help-content
    margin-top : 16px
    .help-content-item
      margin-top : 32px
      .help-item-title
        line-height : 40px
        font-size : 32px
        font-weight: normal
        font-stretch: normal
        letter-spacing: 0px
        color: #4282e1
      .help-item-desc
        padding : 8px 16px 0 16px
        line-height : 38px
        font-size : 28px
        font-weight: normal
        font-stretch: normal
        letter-spacing: 0px
        color: #333333
</style>
